import React from "react";

const RequestsAll = React.createContext();

export default RequestsAll;
